import { Box, Flex } from "@chakra-ui/react";
import { LandingHeader } from "../layouts/Header";
import {FooterInfo} from "../layouts/Footer";
import { MilestoneContainer } from "../features/milestones";

export function MilestonesPage() {
    return (
        <Flex flexDirection="column" height="100vh">
            <Box width="full" position="sticky" top="0" zIndex="sticky">
                <LandingHeader />
            </Box>

            {/* Scrollable Main Content */}
            <Box as="main" flex="1">
                <MilestoneContainer />
            </Box>

            <FooterInfo />
        </Flex>
    );
}
